export { default as LifestylesTonesFilterBadge } from './LifestylesTonesFilterBadge';
